import { render, staticRenderFns } from "./ShareModalEmailItem.vue?vue&type=template&id=532fc300&scoped=true&"
import script from "./ShareModalEmailItem.vue?vue&type=script&lang=js&"
export * from "./ShareModalEmailItem.vue?vue&type=script&lang=js&"
import style0 from "./ShareModalEmailItem.vue?vue&type=style&index=0&id=532fc300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532fc300",
  null
  
)

export default component.exports